export const loadValuesFromVector = (vector) => {
  let value = vector
  if (typeof (vector) === 'object' && vector.hasOwnProperty('Value')) {
    value = vector.Value
  }

  return value
}

export const prepareScenarioVectors = (root, cpr = null, cdr = null) => {
  let scenario = {};

  if (root.selectedScenario != null) {
    scenario.cpr = root.selectedScenario.data.Cpr
    scenario.cdr = root.selectedScenario.data.Cdr
    scenario.lossSeverity = root.selectedScenario.data.LossSeverity
    scenario.delinquency = root.selectedScenario.data.Delinquency
  } else {
    scenario.cpr = cpr || loadValuesFromVector(root.cpr)
    scenario.cdr = cdr || loadValuesFromVector(root.cdr)
    scenario.lossSeverity = loadValuesFromVector(root.lossSeverity)
    scenario.delinquency = loadValuesFromVector(root.delinquency)
  }

  return scenario
}
